import { bindable, BindingMode, inject } from 'aurelia';

@inject(Element)

export class NumberInputCustomElement {
  @bindable({ mode: BindingMode.twoWay }) value;
  @bindable maxlength;
  @bindable class;
  @bindable placeholder;
  @bindable tabindex;

  constructor(element) {
    this.element = element;
    this.isAttached = false;
  }

  bound() {
    this.input.addEventListener('keydown', e => this.keydown(e));
    this.input.addEventListener('blur', this.blur);
  }

  attached() {
    if (!this.placeholder) this.placeholder = '';
    if (!this.maxlength) this.maxlength = '20';
    this.isAttached = true;
  }

  keydown(e) {
    const allowedKeys = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', 'Backspace', 'Delete', 'Alt', 'Tab', 'Shift', 'ArrowRight', 'ArrowLeft', 'ArrowUp', 'ArrowDown']
    if (allowedKeys.indexOf(e.key) < 0 && !e.ctrlKey) {
      e.preventDefault();
    }
  }
}
